import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export const PromoBanner = ({ settings, onToggle }) => {
  const { lang, pick } = useLang();
  const [open, setOpen] = useState(true);
  const text = pick(settings, "promo_text");

  if (!settings?.promo_enabled || !text) return null;

  const close = () => {
    setOpen(false);
    onToggle?.(false);
  };

  const chunk = (
    <span className="flex items-center whitespace-nowrap">
      <span className="font-label text-xs md:text-sm font-bold tracking-wide px-8">{text}</span>
      <span className="text-maize">✳</span>
    </span>
  );

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 40, opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="promo-banner"
          className="fixed top-0 left-0 right-0 z-[60] bg-terracotta text-dough overflow-hidden flex items-center"
          style={{ height: 40 }}
        >
          <div className="marquee" style={{ animationDuration: "26s" }}>
            {[...Array(8)].map((_, i) => (
              <span key={i} className="flex items-center">{chunk}</span>
            ))}
          </div>
          <button
            onClick={close}
            data-testid="promo-close"
            aria-label="Cerrar"
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-ink/20 hover:bg-ink/40 rounded-full p-1 transition-colors"
          >
            <X size={14} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
